import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  base: {
    appearance: 'none',
    boxSizing: 'border-box',
    margin: 0,
    '::before': {
      content: '',
      display: 'block',
      width: '20px',
      height: '20px',
      border: `1px solid ${colors.tertiaryBorder}`,
      borderRadius: '2px',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: '50% 50%',
      cursor: 'pointer',
    },
  },
  checked: (size) => ({
    '::before': {
      backgroundColor: colors.accentBackground,
      borderColor: colors.accentBackground,
      backgroundImage:
        size === 'small'
          ? `url("data:image/svg+xml,%3Csvg width='8' height='7' viewBox='0 0 8 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 1L3.83634 5.25454C3.72725 5.47272 3.50906 5.5818 3.29088 5.5818C3.0727 5.5818 2.85455 5.47273 2.63636 5.36364L1 3.72727' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")`
          : `url("data:image/svg+xml,%3Csvg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.75 1.5L4.79542 6.81817C4.65906 7.0909 4.38633 7.22725 4.1136 7.22725C3.84088 7.22725 3.56818 7.09091 3.29545 6.95454L1.25 4.90909' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")`,
    },
  }),
  hover: (isChecked) => ({
    '::before': {
      backgroundColor: isChecked ? colors.accentBackground : colors.hoverBackground, // TODO: цвет ?
      borderColor: isChecked ? colors.accentBackground : colors.hoverBorder,
    },
  }),
  disabled: (size, isChecked) => ({
    '::before': {
      cursor: 'not-allowed',
      backgroundColor: null,
      borderColor: colors.ghostBorder,
      backgroundImage:
        isChecked &&
        (size === 'small'
          ? `url("data:image/svg+xml,%3Csvg width='8' height='7' viewBox='0 0 8 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 1L3.83634 5.25454C3.72725 5.47272 3.50906 5.5818 3.29088 5.5818C3.0727 5.5818 2.85455 5.47273 2.63636 5.36364L1 3.72727' stroke='%231D252D' stroke-opacity='0.25' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")`
          : `url("data:image/svg+xml,%3Csvg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.75 1.5L4.79542 6.81817C4.65906 7.0909 4.38633 7.22725 4.1136 7.22725C3.84088 7.22725 3.56818 7.09091 3.29545 6.95454L1.25 4.90909' stroke='%231D252D' stroke-opacity='0.25' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")`),
    },
  }),
  indeterminate: (isDisabled, isChecked) => ({
    '::before': {
      backgroundImage: isDisabled
        ? `url("data:image/svg+xml,%3Csvg width='10' height='2' viewBox='0 0 10 2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1H9' stroke='grey' stroke-opacity='0.3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")`
        : isChecked
          ? `url("data:image/svg+xml,%3Csvg width='10' height='2' viewBox='0 0 10 2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1H9' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")`
          : null,
    },
  }),
  small: {
    '::before': {
      width: '16px',
      height: '16px',
      border: `1px solid ${colors.tertiaryBorder}`,
    },
  },
  medium: {
    '::before': {
      width: '18px',
      height: '18px',
      border: `1px solid ${colors.tertiaryBorder}`,
    },
  },
  large: {
    '::before': {
      width: '20px',
      height: '20px',
      border: `1px solid ${colors.tertiaryBorder}`,
    },
  },
});
